// extracted by mini-css-extract-plugin
module.exports = {"user-image__wrapper":"UserImage_user-image__wrapper__DZi6Y","active":"UserImage_active__qCTT1","user-image__letters":"UserImage_user-image__letters__nEavc"};